<template>
  <v-card outlined>
    <v-card-title>
      <v-row align="center">
        <v-col>
          <div class="title">Customer info</div>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text>
      <v-divider class="pb-6"></v-divider>

      <customer-create-edit-form
        @cancelled="
          $router.push({
            name: 'customer',
            params: { customer_id: customer.id }
          })
        "
      ></customer-create-edit-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import CustomerCreateEditForm from '@/components/customers/CustomerCreateEditForm'

export default {
  name: 'CustomerSettings',
  components: {
    CustomerCreateEditForm
  },
  computed: {
    ...mapState('customers', ['customer'])
  }
}
</script>
